export default "__VITE_PUBLIC_ASSET__689651a7__"